import React from "react";

interface FlagDisplayProps {
  flag?: string;
  size?: number; // px, default 16
  className?: string;
}

/**
 * FlagDisplay — renders a language flag safely.
 *
 * Handles two formats:
 *   1. URL  — e.g. "https://example.com/flags/us.png"  → <img>
 *   2. Code — e.g. "flag_us", "🇺🇸", or any non-URL string → <span>
 */
export const FlagDisplay: React.FC<FlagDisplayProps> = ({
  flag,
  size = 16,
  className = "",
}) => {
  if (!flag) return null;

  const isUrl =
    flag.startsWith("http://") ||
    flag.startsWith("https://") ||
    flag.startsWith("/");

  if (isUrl) {
    return (
      <img
        src={flag}
        alt="flag"
        width={size}
        height={size}
        className={`inline-block rounded-sm object-cover ${className}`}
        style={{ width: size, height: size }}
        onError={(e) => {
          // If image fails to load, hide it gracefully
          (e.target as HTMLImageElement).style.display = "none";
        }}
      />
    );
  }

  // Emoji or text code — render as-is
  return <span className={className}>{flag}</span>;
};
